import React, { useState } from "react";
import SplashScreen from "./Screens/SplashScreen";

function App() {
  return (
    <div className="App">
      <SplashScreen />
    </div>
  );
}

export default App;